import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";

import Dt_Cal from "../../lib/ui/dt_cal";
import ddo from "../../ddo";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Pos_Stat_Drift extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.pos = props.store.pos;
    this.state = {};
    this.state.today = new Date();
    this.state.seldate = new Date();
    this.state.avd = ddo.cache.avd;
    this.state.tra = [];
    this.state.aa = [];
    //context.posrend = this;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.st_trs();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 250;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  st_trs() {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_eko.trs";
    prm.avd = ddo.cache.avd;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        var tra = ret.rca.filter(rrs00 => {
            if(rrs00.r0ttyp.includes('J')) return false;
            if(rrs00.r0etyp.includes('NOTA')) return false;
            return true;
        });
        self.setState({tra: tra });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }

  render() {
    return (
    <div className="web-p00 flex flex-col">
        <div className="">
            Drift
        </div>

    <div className="web-p01">
    <div className="flex-row">
        <Dt_Cal startdatum="2020-02-01" getValue={(e)=> this.setState({seldate: e}) }/>
        <select className="form-control w250 hide" placeholder="Välj avdelning">
            { this.pos.deps.map((row, key) =>
            <option key={key} value={row.id}>{row.text}</option>
            )}
        </select>
        <div className="flex"></div>

        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.st_trs() } aria-label="System" >
            UPPDATERA
        </button>
    </div>
    <div className="divider_orange"></div>

    <div className="web-row">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
				<th>Datum</th>
				<th>Tid</th>
				<th>PLU</th>
				<th>Text</th>
				<th>Antal</th>
				<th>Pris</th>
				<th>Summa</th>
				<th>Procent</th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.tra.map((rrs00, key) =>
            <tr key={key} id={ rrs00.r0datum } onDoubleClick={() => this.plu_open(rrs00) }>
                <td>{ rrs00.r0datum.cdidate() }</td>
                <td>{ rrs00.r0time.cditid() }</td>
                <td>{ rrs00.r0etyp }</td>
                <td>{ rrs00.r0text.toswe() }</td>
                <td>{ rrs00.r0noof.ztrim() }</td>
                <td>{ rrs00.r0perprice.cdipris() }</td>
                <td>{ (rrs00.r0noof * rrs00.r0perprice).toString().cdipris() }</td>
                <td>{ rrs00.r0vatproc.dec2() }</td>
            </tr>
            )}
            </tbody>
        </table>
    </div>

    </div>
    </div>
  );
    }
}
export default Pos_Stat_Drift;
